export default function CreateDisconnectionWorkItemModel(mergedData) {
  return {
    workorderid: mergedData.id,
    workordername: `${mergedData.categoryName} at ${mergedData.siteName}`,
    workordercategoryid: mergedData.category,
    workordercategoryname: mergedData.categoryName,
    siteid: mergedData.siteId,
    sitename: mergedData.siteName,
    propertyid: mergedData.propertyId,
    propertyname: mergedData.propertyName,
    propertynumber: mergedData.propertyNumber,
    customerresidentname: mergedData.customername,
    workitemtemplateid: mergedData.workitemtemplateid,
    workitemtemplateref: mergedData.workitemtemplateref,
    jobspecificaccessnotes: mergedData.jobSpecificAccessNotes,
    name: `${mergedData.categoryName} at ${mergedData.siteName}`,
    disconnectelectricity: mergedData.disconnectelectricity,
    disconnectheat: mergedData.disconnectheat,
    disconnecthotwater: mergedData.disconnecthotwater,
    propertyaccessnotes: mergedData.propertyaccessnotes,
    redflag: mergedData.redflag,
    idempotencyGuid: mergedData.idempotencyGuid,
    createdBy: mergedData.createdBy,
    noAccessattempts: mergedData.noAccessAttempts,
  };
}
